class FacetDropdowns {
    constructor() {
        this.dropdowns = document.querySelectorAll('.facet-dropdown-wrapper');
        this.init();
    }

    init() {
        this.dropdowns.forEach((wrapper) => {
            this.setupDropdown(wrapper);
        });

        this.setupComplexGroups();

        document.addEventListener('click', (e) => {
            if (!e.target.closest('.facet-dropdown-wrapper')) {
                this.closeAllDropdowns();
            }
        });

        this.syncCheckboxesFromURL();
        this.syncDisabledStatesFromDOM();
    }

    restoreOpenDropdown() {
        if (this.openDropdownId) {
            const dropdown = document.querySelector(`[aria-controls="${this.openDropdownId}"]`);
            if (dropdown) {
                const wrapper = dropdown.closest('.facet-dropdown-wrapper');
                if (wrapper) {
                    this.openDropdown(wrapper);
                }
            }
        }
    }

    openDropdown(wrapper) {
        const trigger = wrapper.querySelector('.facet-dropdown-trigger');
        const content = wrapper.querySelector('.facet-dropdown-content');

        if (trigger && content) {
            trigger.setAttribute('aria-expanded', 'true');
            content.classList.remove('hidden');
            this.openDropdownId = trigger.getAttribute('aria-controls');
        }
    }

    syncDisabledStatesFromDOM() {
        const checkboxes = document.querySelectorAll('.facet-dropdown-wrapper .facet-checkbox');

        checkboxes.forEach(checkbox => {
            const label = checkbox.closest('label, .facet-option-label');
            if (!label) return;

            const countElement = label.querySelector('.facet-option-count, .facet-count');

            if (countElement) {
                const countText = countElement.textContent.trim();
                const match = countText.match(/\((\d+)\)/);
                const count = match ? parseInt(match[1]) : 0;

                const shouldBeDisabled = count === 0 && !checkbox.checked;

                checkbox.disabled = shouldBeDisabled;

                if (shouldBeDisabled) {
                    label.classList.add('disabled');
                } else {
                    label.classList.remove('disabled');
                }
            } else {
                checkbox.disabled = false;
                label.classList.remove('disabled');
            }
        });
    }

    syncCheckboxesFromURL() {
        const params = new URLSearchParams(window.location.search);
        const activeFilters = new Map();

        for (const [key, value] of params.entries()) {
            if (key.startsWith('filter.')) {
                if (!activeFilters.has(key)) {
                    activeFilters.set(key, []);
                }
                activeFilters.get(key).push(value);
            }
        }

        const form = document.querySelector('.facet-filters-horizontal form[is="facet-form"]');

        if (form) {
            form.removeEventListener('change', form.onFormChange);
        }

        const checkboxes = document.querySelectorAll('.facet-dropdown-wrapper .facet-checkbox');

        checkboxes.forEach(checkbox => {
            const paramName = checkbox.getAttribute('name');
            const paramValue = checkbox.getAttribute('value');

            if (paramName && paramValue) {
                const activeValues = activeFilters.get(paramName) || [];
                const shouldBeChecked = activeValues.includes(paramValue);

                if (checkbox.checked !== shouldBeChecked) {
                    checkbox.checked = shouldBeChecked;
                }
            }
        });

        if (form) {
            setTimeout(() => {
                form.addEventListener('change', form.onFormChange);
            }, 100);
        }

        this.updateTriggerCounts();
    }

    setupDropdown(wrapper) {
        const trigger = wrapper.querySelector('.facet-dropdown-trigger');
        const content = wrapper.querySelector('.facet-dropdown-content');
        const searchInput = wrapper.querySelector('.facet-search-input');
        const items = wrapper.querySelectorAll('.facet-dropdown-item');

        if (!trigger || !content) {
            return;
        }

        const newTrigger = trigger.cloneNode(true);
        trigger.parentNode.replaceChild(newTrigger, trigger);

        newTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.toggleDropdown(wrapper);
        });

        if (searchInput) {
            searchInput.addEventListener('input', (e) => {
                const searchTerm = e.target.value.toLowerCase();
                items.forEach(item => {
                    const filterValue = item.getAttribute('data-filter-value') || '';
                    item.style.display = filterValue.includes(searchTerm) ? '' : 'none';
                });
            });

            searchInput.addEventListener('click', (e) => {
                e.stopPropagation();
            });
        }

        content.addEventListener('click', (e) => {
            e.stopPropagation();
        });

        const checkboxes = content.querySelectorAll('.facet-checkbox');
        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', () => {
                this.updateTriggerCounts();
            });
        });
    }

    setupComplexGroups() {
        const complexGroupHeaders = document.querySelectorAll('.facet-complex-group-header');

        complexGroupHeaders.forEach((header) => {
            const newHeader = header.cloneNode(true);
            header.parentNode.replaceChild(newHeader, header);

            const groupContent = newHeader.nextElementSibling;

            newHeader.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const isExpanded = newHeader.getAttribute('aria-expanded') === 'true';

                newHeader.setAttribute('aria-expanded', !isExpanded);

                if (!isExpanded) {
                    groupContent.classList.remove('hidden');
                    newHeader.classList.add('is-expanded');
                } else {
                    groupContent.classList.add('hidden');
                    newHeader.classList.remove('is-expanded');
                }
            });

            const groupSearchInput = groupContent?.querySelector('.facet-search-input');
            if (groupSearchInput) {
                groupSearchInput.addEventListener('input', (e) => {
                    const searchTerm = e.target.value.toLowerCase();
                    const items = groupContent.querySelectorAll('.facet-dropdown-item');

                    items.forEach(item => {
                        const filterValue = item.getAttribute('data-filter-value') || '';
                        item.style.display = filterValue.includes(searchTerm) ? '' : 'none';
                    });
                });

                groupSearchInput.addEventListener('click', (e) => {
                    e.stopPropagation();
                });
            }

            if (groupContent) {
                groupContent.addEventListener('click', (e) => {
                    e.stopPropagation();
                });
            }
        });
    }

    toggleDropdown(wrapper) {
        const trigger = wrapper.querySelector('.facet-dropdown-trigger');
        const content = wrapper.querySelector('.facet-dropdown-content');
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

        this.closeAllDropdowns();

        if (!isExpanded) {
            trigger.setAttribute('aria-expanded', 'true');
            content.classList.remove('hidden');

            this.openDropdownId = trigger.getAttribute('aria-controls');

            const searchInput = content.querySelector('.facet-search-input');
            if (searchInput) {
                setTimeout(() => searchInput.focus(), 100);
            }
        } else {
            this.openDropdownId = null;
        }
    }

    closeAllDropdowns() {
        this.dropdowns.forEach(wrapper => {
            const trigger = wrapper.querySelector('.facet-dropdown-trigger');
            const content = wrapper.querySelector('.facet-dropdown-content');
            if (trigger && content) {
                trigger.setAttribute('aria-expanded', 'false');
                content.classList.add('hidden');
            }

            const searchInputs = content?.querySelectorAll('.facet-search-input');
            if (searchInputs) {
                searchInputs.forEach(input => {
                    input.value = '';
                });
            }

            const items = content?.querySelectorAll('.facet-dropdown-item');
            if (items) {
                items.forEach(item => {
                    item.style.display = '';
                });
            }
        });

        this.openDropdownId = null;
    }

    refresh() {
        this.dropdowns = document.querySelectorAll('.facet-dropdown-wrapper');

        this.dropdowns.forEach((wrapper) => {
            this.setupDropdown(wrapper);
        });

        this.setupComplexGroups();
        this.syncCheckboxesFromURL();
        this.syncDisabledStatesFromDOM();
    }

    updateTriggerCounts() {
        this.dropdowns.forEach(wrapper => {
            const trigger = wrapper.querySelector('.facet-dropdown-trigger');
            if (!trigger) return;

            const labelSpan = trigger.querySelector('.facet-dropdown-label');
            let activeCountSpan = labelSpan?.querySelector('.facet-active-count');

            const checkboxes = wrapper.querySelectorAll('.facet-checkbox:checked');
            const activeCount = checkboxes.length;

            if (activeCount > 0) {
                if (!activeCountSpan) {
                    activeCountSpan = document.createElement('span');
                    activeCountSpan.className = 'facet-active-count';
                    labelSpan.appendChild(activeCountSpan);
                }
                activeCountSpan.textContent = ` (${activeCount})`;
            } else if (activeCountSpan) {
                activeCountSpan.remove();
            }
        });
    }
}

let facetDropdownsInstance = null;
let reinitTimeout = null;

function initFacetDropdowns() {
    if (facetDropdownsInstance) {
        facetDropdownsInstance = null;
    }

    facetDropdownsInstance = new FacetDropdowns();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFacetDropdowns);
} else {
    initFacetDropdowns();
}

document.addEventListener('shopify:section:load', () => {
    setTimeout(initFacetDropdowns, 100);
});

document.addEventListener('facets:updated', () => {
    clearTimeout(reinitTimeout);

    reinitTimeout = setTimeout(() => {
        initFacetDropdowns();
    }, 200);
});